let getters = {
    images: state => {
        return state.images
	},
	image: state => {
        return state.image
    },
	pages: state => {
        return state.pages
    },
	page: state => {
        return state.page
    },
    selectedImageIds: state => {
    	return state.selectedImageIds
    },
    previewAnnotations: state => {
    	return state.previewAnnotations
    },
    searchParams: state => {
        return state.searchParams
    },
    isSearching: state => {
        return state.isSearching
    },
    isSearched: state => {
        return state.isSearched
    },
    cancelSourceForSearch: state => {
        return state.cancelSourceForSearch
    },
}

export default getters